module.exports = __webpack_public_path__ + "img/Nicolas.b81b70f7.png";